<template>
	<div
		class="v-accordion-group" :id="id">
		<slot :open="open" :close="close" :toggle="toggle"/>
	</div>
</template>
<script>
export default {
	computed: {},

	props: {
		id: {
			required: false,
			type: String,
			default() {
				return "v-accordion-group--" + this._uid;
			}
		},
		single: {
			required: false,
			type: Boolean,
			default: true,
		}
	},

	methods: {
		accordionClosing(id) {
			this.$emit("accordionClosing", id);
		},
		accordionClosed(id) {
			this.$emit("accordionClosed", id);
		},
		accordionOpening(id) {
			this.$emit("accordionOpening", id);

			if (!this.single) {
				return;
			}

			_.each(this.accordions(), accordion => {
				if (accordion.id === id) {
					return;
				}
				accordion.close();
			});
		},
		accordionOpened(id) {
			this.$emit("accordionOpened", id);
		},
		accordions() {
			return _.filter(this.$children, child => {
				return child.$options?._componentTag === "accordion";
			});
		},
		toggle(id) {
			this.findAccordion(id)?.toggle();
		},
		open(id) {
			this.findAccordion(id)?.open();
		},
		close(id) {
			this.findAccordion(id)?.close();
		},
		findAccordion(id) {
			return _.first(this.accordions(), accordion => {
				return accorion.id === id;
			});
		},
	}
};
</script>
